import { createContext, useContext, useState } from 'react';

const UserContext = createContext();

const initialState = {
  alertProps: {},
};

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  sort: { field: 'id', order: 'desc' },
  role: null,
  brand: null,
  platform: null,
  status: null,
};

const UserProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return <UserContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>{children}</UserContext.Provider>;
};

export const useUserState = () => {
  return useContext(UserContext);
};

export default UserProvider;
